<template>
  <div>
    <div class="header-blue">
        
        <div class="container hero flex px-4">
            <div class="row w-1/2">
                <div class="col-12 col-lg-6 col-xl-5 offset-xl-1">
                    <h2 class="text-white text-4xl font-bold py-14">Welcome to PetWare</h2>
                    <h3 class="py-4 text-xl text-white leading-relaxed">
                        If you are looking for a fabulous array of designer dog and cat clothing, 
                        you have come to the right place. Our designer dog and cat clothing collections 
                        include a huge selection of dog and cat shirts, dog and cat sweaters, dog cand cat 
                        oats, dog and cat dresses, dog and cat pajamas, and even dog Halloween costumes that
                         will make all the other dogs and cats drool with envy.
                    </h3> 

                    <div class="space-x-4">

                        <a href="http://localhost:8080/index.html#/woof"><button class="btn btn-light btn-lg action-button" type="button">Shop For Dogs<i class="fa fa-long-arrow-right ml-2"></i></button>
                        </a>

                        <a href="http://localhost:8080/index.html#/meow"> <button class="btn btn-light btn-lg action-button" type="button">Shop For Cats<i class="fa fa-long-arrow-right ml-2"></i></button>
                        </a>
                    </div>
                </div>
            </div>
                <div class="col-md-5 col-lg-5 offset-lg-1 offset-xl-0 d-none d-lg-block">
                    <div> <img src="https://ucarecdn.com/1ded3705-b475-46f7-897c-9f93a863d5df/petshop.png">
                    </div>
                </div>
            
        </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>

@media (min-width:768px) {
    .header-blue .hero {
        margin-top: 60px;
        text-align: left
    }
}

.header-blue .hero p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    margin-bottom: 30px;
    font-weight: 300
}


</style>